import { Injectable } from "@angular/core";
import { EngagementProDataProviderService } from "../../engagement/engagement.pro.providers.service";
import { OpporunityProDataProviderService } from "../../opporunity/opportunity.stemexe.providers.service";
import { PlannexeDataProviderService } from "../../plannexe/stemexe-providers.service";
import { EspDataProviderService } from "../../requests/esp/common/services/esp-data-provider.service";
import { AuthService, AuthType } from "../../shared/services/auth.service";
import { SimpleStrataDataProviderService } from "../../shared/services/simplestrata-auth.service";
import { SharedService } from "../../shared/shared.service";
import { IStemexeModule } from "../interfaces/interfaces";
import { StemexeDataProviderService } from "./stemexe-data-provider.service";
import { HigherDataProviderService } from "src/app/vacancy/higher-providers.service";
import { TechnadoptDataProviderService } from "src/app/products/stemexe-providers.service";

@Injectable({
    providedIn: 'root'
})

export class StemexeClientService {

    constructor(
        private auth: AuthService,
        private stemexeDataProvider: StemexeDataProviderService,
        private ssDataProider: SimpleStrataDataProviderService,
        private espDataProvider: EspDataProviderService,
        private plannexeDataProider: PlannexeDataProviderService,
        private engProDataProviderService: EngagementProDataProviderService,
        private oppProDataProviderService: OpporunityProDataProviderService,
        private higherDataProviderService: HigherDataProviderService,
        private technadoptDataProviderService: TechnadoptDataProviderService,
        private sharedService: SharedService
    ) {
        this.auth.registerClientDataProvider$.subscribe((clientModuleType: AuthType) => {
            this.registerDataProvider(clientModuleType);
        })

        this.sharedService.addonDelete$.subscribe((clientModuleType: AuthType) => {
            this.disconnectDataProvider(clientModuleType)
        })
    }

    registerDataProvider(clientModuleType: AuthType) {
        let module: IStemexeModule = null;
        switch (clientModuleType.toLowerCase()) {
            case AuthType.SimpleStrata.toLowerCase():
                module = this.ssDataProider;
                break;
            case AuthType.ESP.toLowerCase():
                module = this.espDataProvider;

                break;
            case AuthType.EngagementPro.toLowerCase():
                module = this.plannexeDataProider;
                break;
            case AuthType.Plannexe.toLowerCase():
                module = this.engProDataProviderService;
                break;
            case AuthType.OppPro.toLowerCase():
                module = this.oppProDataProviderService;
                break;
            case AuthType.Higher.toLowerCase():
                module = this.higherDataProviderService;
                break;
            case AuthType.Technadopt.toLowerCase():
                module = this.technadoptDataProviderService;
                break;
            default:
                break;
        }

        if (module) {
            this.stemexeDataProvider.registerDataProvider(module)
        }
    }

    disconnectDataProvider(clientModuleType: AuthType) {
        this.stemexeDataProvider.disconnectDataProvider(clientModuleType)
    }
    disconnectAllDataProviders() {
        this.stemexeDataProvider.disconnectAllDataProviders()
    }

}




